"use strict";
/**
 * AUTOGENERATED
 *
 * DO NOT MODIFY
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.JO = void 0;
exports.JO = {
    numericCode: '400',
    alpha2Code: 'JO',
    alpha3Code: 'JOR',
    englishName: {
        short: 'Jordan',
        full: 'the Hashemite Kingdom of Jordan',
    },
    names: {
        full: {
            en: 'the Hashemite Kingdom of Jordan',
            fr: 'le Royaume hachémite de Jordanie',
            ar: 'Al Urdun',
        },
        short: {
            en: 'Jordan',
            fr: 'Jordanie (la)',
            ar: 'Al Urdun',
        },
    },
    languages: [
        {
            languageAlpha2Code: 'ar',
            languageAlpha3Code: 'ara',
            isAdministrative: true,
        },
        {
            languageAlpha2Code: 'en',
            languageAlpha3Code: 'eng',
            isAdministrative: false,
        },
        {
            languageAlpha2Code: 'fr',
            languageAlpha3Code: 'fra',
            isAdministrative: false,
        },
    ],
    subdivisions: {
        'JO-AJ': {
            numericCode: '400',
            code: 'JO-AJ',
            category: {
                id: '420',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: '‘Ajlūn',
            },
        },
        'JO-AM': {
            numericCode: '400',
            code: 'JO-AM',
            category: {
                id: '420',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Al ‘A̅şimah',
            },
        },
        'JO-AQ': {
            numericCode: '400',
            code: 'JO-AQ',
            category: {
                id: '420',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Al ‘Aqabah',
            },
        },
        'JO-AT': {
            numericCode: '400',
            code: 'JO-AT',
            category: {
                id: '420',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Aţ Ţafīlah',
            },
        },
        'JO-AZ': {
            numericCode: '400',
            code: 'JO-AZ',
            category: {
                id: '420',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Az Zarqā’',
            },
        },
        'JO-BA': {
            numericCode: '400',
            code: 'JO-BA',
            category: {
                id: '420',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Al Balqā’',
            },
        },
        'JO-IR': {
            numericCode: '400',
            code: 'JO-IR',
            category: {
                id: '420',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Irbid',
            },
        },
        'JO-JA': {
            numericCode: '400',
            code: 'JO-JA',
            category: {
                id: '420',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Jarash',
            },
        },
        'JO-KA': {
            numericCode: '400',
            code: 'JO-KA',
            category: {
                id: '420',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Al Karak',
            },
        },
        'JO-MA': {
            numericCode: '400',
            code: 'JO-MA',
            category: {
                id: '420',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Al Mafraq',
            },
        },
        'JO-MD': {
            numericCode: '400',
            code: 'JO-MD',
            category: {
                id: '420',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Mādabā',
            },
        },
        'JO-MN': {
            numericCode: '400',
            code: 'JO-MN',
            category: {
                id: '420',
                names: {
                    ar: {
                        singular: 'muḩāfaz̧ah',
                        plural: '',
                    },
                    en: {
                        singular: 'governorate',
                        plural: 'governorates',
                    },
                    fr: {
                        singular: 'gouvernorat',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                ar: 'Ma‘ān',
            },
        },
    },
    cities: [
        {
            name: 'Wādī as Sīr',
            subdivision: 'Amman',
        },
        {
            name: 'Umm as Summāq',
            subdivision: 'Amman',
        },
        {
            name: 'Saḩāb',
            subdivision: 'Amman',
        },
        {
            name: 'Mādabā',
            subdivision: 'Madaba',
        },
        {
            name: "Ma'an",
            subdivision: 'Ma’an',
        },
        {
            name: 'Kurayyimah',
            subdivision: 'Irbid',
        },
        {
            name: 'Judita',
            subdivision: 'Irbid',
        },
        {
            name: 'Jarash',
            subdivision: 'Jerash',
        },
        {
            name: '‘Izrā',
            subdivision: 'Karak',
        },
        {
            name: 'Irbid',
            subdivision: 'Irbid',
        },
        {
            name: 'Zarqa',
            subdivision: 'Zarqa',
        },
        {
            name: 'Aydūn',
            subdivision: 'Irbid',
        },
        {
            name: 'Aţ Ţafīlah',
            subdivision: 'Tafielah',
        },
        {
            name: 'As Salţ',
            subdivision: 'Balqa',
        },
        {
            name: 'Safi',
            subdivision: 'Karak',
        },
        {
            name: 'Ar Ramthā',
            subdivision: 'Irbid',
        },
        {
            name: '‘Anjarah',
            subdivision: 'Ajlun',
        },
        {
            name: 'Amman',
            subdivision: 'Amman',
        },
        {
            name: 'Al Quwaysimah',
            subdivision: 'Amman',
        },
        {
            name: 'Mafraq',
            subdivision: 'Mafraq',
        },
        {
            name: 'Qīr Moāv',
            subdivision: 'Ma’an',
        },
        {
            name: 'Al Jubayhah',
            subdivision: 'Amman',
        },
        {
            name: 'Aqaba',
            subdivision: 'Aqaba',
        },
        {
            name: '‘Ajlūn',
            subdivision: 'Ajlun',
        },
        {
            name: 'Karak City',
            subdivision: 'Karak',
        },
        {
            name: 'Russeifa',
            subdivision: 'Zarqa',
        },
    ],
};
//# sourceMappingURL=data:application/json;base64,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